document.addEventListener("DOMContentLoaded", () => {
  // Only run on collection pages
  if (!window.location.pathname.startsWith("/collections/")) return;

  const url = new URL(window.location.href);
  const sp = url.searchParams;

  // Remove EMPTY params only (safe)
  for (const [k, v] of Array.from(sp.entries())) {
    if (v === "" || v == null) sp.delete(k);
  }

  // Remove DEFAULT grid view param (safe)
  if (sp.get("grid_list") === "grid-view") sp.delete("grid_list");

  const qs = sp.toString();
  const cleaned = url.pathname + (qs ? `?${qs}` : "") + url.hash;
  const current = window.location.pathname + window.location.search + window.location.hash;

  if (cleaned !== current) {
    window.history.replaceState({}, "", cleaned);
  }
});
